export function maskEmail(email: string): string {
  if (!email || typeof email !== "string") {
    return email;
  }
  const idx = email.indexOf("@");
  const first = email[0];
  const endOfEmail = idx > 3 ? email.slice(idx - 1) : email.slice(idx);
  return `${first}******${endOfEmail}`;
}
